import SystemCustomization from "./SystemCustomization";

export default SystemCustomization;